"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = require("prop-types");

var strOrNum = (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]);

var _default = (0, _propTypes.oneOfType)([strOrNum, (0, _propTypes.arrayOf)(strOrNum)]);

exports["default"] = _default;